import React from "react";
import NascarOptimizer from "./NascarOptimizer";

export default function CupOptimizerPage() {
  return <NascarOptimizer forcedSeries="cup" />;
}
